import {
  EditContextProvider,
  SimpleForm,
  TextInput,
  BooleanInput,
  useEditController,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";

export const EducationalInstitutionEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "educational-institutions/crud",
    id,
    mutationMode: "pessimistic",
  });

  return (
    <EditContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Instituição de Ensino"
          firstPath="/#/educational-institutions/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Instituição de Ensino" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput source="id" fullWidth helperText={false} disabled />
                <TextInput
                  source="name"
                  fullWidth
                  helperText={false}
                  label="Nome"
                />
                <BooleanInput
                  source="reviewed"
                  fullWidth
                  helperText={false}
                  label="Revisado"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
